import { CheckIcon } from "lucide-react";
import { Checkbox as RadixCheckbox } from "radix-ui";
import type { ComponentRef } from "react";
import { getCheckboxClass } from "./checkbox.styles";
import type { CheckboxProps } from "./checkbox.types";

const { Root, Indicator } = RadixCheckbox;

export function Checkbox({
  ref,
  className,
  ...props
}: CheckboxProps & { ref?: React.RefObject<ComponentRef<typeof Root> | null> }) {
  return (
    <Root {...props} ref={ref} className={getCheckboxClass({ className })}>
      <Indicator className="flex items-center justify-center text-current">
        <CheckIcon className="size-4" />
      </Indicator>
    </Root>
  );
}
